module.exports = __webpack_public_path__ + "img/manual2.c6e97bef.png";